import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SiteSetting {
  id: string;
  key: string;
  language_code: string | null;
  value: string;
}

export const useSiteSettings = () => {
  return useQuery({
    queryKey: ["site-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("*");

      if (error) throw error;
      
      // Convert to a key-value map for easier access
      const settings: Record<string, string> = {};
      (data as SiteSetting[]).forEach((setting) => {
        settings[setting.key] = setting.value;
      });
      
      return settings;
    },
  });
};

export const useSetting = (key: string) => {
  const { data: settings, isLoading, error } = useSiteSettings();
  return {
    value: settings?.[key] || null,
    isLoading,
    error,
  };
};
